import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { catchError, Observable, share, tap, throwError } from 'rxjs';
import { OauthInfo } from '@auto-editor/shared/models';
import { environment } from '@auto-editor/environment';
import { UserService } from '@auto-editor/data-access-user';

@Injectable({
  providedIn: 'root'
})
export abstract class RefreshTokenService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private userService: UserService
  ) {}

  refreshToken(refreshToken: string): Observable<OauthInfo> {
    const headers = this.authService.getBasicAuthHeaders();
    const body = `grant_type=refresh_token&refresh_token=${refreshToken}`;

    return this.http
      .post<OauthInfo>(environment.serverApi + '/oauth/token', body, {
        headers: headers
      })
      .pipe(
        share(), // AVOID MULTIPLE REQUEST BEING SENT SIMULTANEOUSLY
        tap((oauthInfo) => {
          this.authService.saveOauthInfo(oauthInfo);
        }),
        catchError((error: HttpErrorResponse) => {
          this.userService.logOut();
          return throwError(() => error);
        })
      );
  }
}
